import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  selectDetailsFetchData,
  selectDetailsData
} from 'src/core/redux/selectors';
import { User } from 'src/core/models';
import { FetchData } from 'src/core/components';
import LocalStorageService from 'src/core/services/LocalStoregeService';
import { config } from 'src/constants';

import { fetchAccessAndUserData, resetUserDetails } from './actions';
import AppComponent from './AppComponent';

const AppContainer = ({
  isFetching,
  error,
  fetched,
  fetchData,
  resetData,
}) => {
  React.useEffect(() => {
    if (fetched && !(config.isDevEnv)) {
      window.showGlobalFooter();
    }
  }, [fetched]);

  return (
    <FetchData
      isFetching={isFetching}
      error={error}
      fetchData={fetchData}
      resetData={resetData}
    >
      <AppComponent />
    </FetchData>
  );
};

AppContainer.propTypes = {
  isFetching: PropTypes.bool,
  error: PropTypes.string,
  fetched: PropTypes.bool,
  fetchData: PropTypes.func.isRequired,
  resetData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  LocalStorageService.removeItem('loggedUser');

  const userType = selectDetailsData(User, 'type')(state);
  const userDetails = selectDetailsData(User)(state);

  LocalStorageService.setLoggedUser(
    new User({
      ...userDetails,
      isAnonymous: userType.isAnonymous
    })
  );

  const fetchDataProps = selectDetailsFetchData(User)(state);
  const userTypeFetchDataProps = selectDetailsFetchData(User, 'type')(state);

  return {
    isFetching: fetchDataProps.isFetching,
    fetched: userTypeFetchDataProps.fetched,
    error: userType.isAnonymous ? undefined : fetchDataProps.error,
  };
};

const mapDispatchToProps = {
  fetchData: fetchAccessAndUserData,
  resetData: resetUserDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
